/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import 'reflect-metadata'
import {plainToClass, classToPlain} from "class-transformer";
import CoachingProgram from "@/core/js/model/Program/CoachingProgram";


// Vue.use(Vuex)



export default {
	namespaces: false,
	state: {
		programDetailsItem: null,
		clientCurrentProgramArray: [],
		programList: [],
		programTemplateList: [],
		clientList: [],
		clientDetailsItem: {},
		notes: {}
	},
	actions: {

	},
	mutations: {
		setProgramList(state, val){
			console.log("setProgramList: val = ", val)
			state.programList = val
		},
		setProgramTemplateList(state, val){
			console.log("setProgramTemplateList: val = ", val)
			state.programTemplateList = val
		},

		setProgramDetailsItem(state, val){
			console.log("setProgramDetailsItem: val = ", val)
			state.programDetailsItem = val
		},
		setClientList(state, val){
			console.log("setClientList: val = ", val)
			state.clientList = val
		},
		setNotes(state, val) {
			console.log("setNotes: val = ", val)
			let obj = state.notes || {}
			obj[val.id] = val.data;
			state.notes = obj
		},
		setClientCurrentProgramArray(state, val){
			console.log("setClientCurrentProgramArray: val = ", val)
			state.clientCurrentProgramArray = val
		},

		setClientDetailsItem(state, val){
			console.log("setClientDetailsItem: val = ", val)
			state.clientDetailsItem = val
		}

	}
}
